const ReservesTab = ({ loanDetails }) => {
  return (
    <section>
      {loanDetails && (
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td className="fw-bold">Payment reserve:</td>
              <td>{loanDetails["payment_reserve"]}</td>
            </tr>
            <tr>
              <td className="fw-bold">Balance reserve:</td>
              <td>{loanDetails["balance_reserve"]}</td>
            </tr>
          </tbody>
        </table>
      )}
    </section>
  );
};
export default ReservesTab;
